#import "../fragments/sales-automation-stageset.graphql"

mutation DeleteClosedLeadEmailAutomation(
    $emailAutomation: DeleteClosedLeadEmailAutomationInputFieldInput!
) {
    deleteClosedLeadEmailAutomation(input: {emailAutomation: $emailAutomation}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
